import {
  SET_NETWORKS,
  SET_NETWORKS_GROUPINGS,
} from './constants'

const mutations = {
  [SET_NETWORKS_GROUPINGS] (state, groupings) {
    state.groupings = groupings
  },
  [SET_NETWORKS] (state, networks) {
    state.networks = networks
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/networks/store/mutations.js